export const ownedCssColor = '#0792FF';
export const administeredCssColor = '#D90000';
export const relatedCssColor = '#76FF29';


// WEBPACK FOOTER //
// ./src/Atollon/Instance/InstanceRoles/InstanceRoleColor.js